import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Components
import DoughSelector from './DoughSelector';
import SizeSelector from '../SizeSelector';
import BorderToggle from './BorderToggle';

// Styles
import styles from './PizzaSelector.styl';

const cx = classNames.bind(styles);

export default function PizzaSelector(props) {
  const {
    selectStuffedCrust,
    className,
    doughTypes,
    currentDough,
    changeDough,
    sizes,
    currentSize,
    changeSize,
    stuffedCrustIsAvailable,
    stuffedCrustsAvailable,
    activeStuffedCrust,
    toggleStuffedCrust,
    leftSidePizzaId,
    rightSidePizzaId,
  } = props;

  useEffect(() => {
    // если выбранный борт стал недоступен, то сбрасываем к доступному
    const newStuffedCrust = stuffedCrustsAvailable.includes(activeStuffedCrust)
      ? activeStuffedCrust
      : stuffedCrustsAvailable[0] || 'none';

    toggleStuffedCrust(newStuffedCrust);
  }, [currentSize, currentDough, leftSidePizzaId, rightSidePizzaId]);

  return (
    <div className={cx('PizzaSelector', className)}>
      {doughTypes && (
        <DoughSelector
          className={cx('PizzaSelector__dough')}
          types={doughTypes}
          currentDough={currentDough}
          onChange={changeDough}
        />
      )}
      <div className={cx('PizzaSelector__variations')}>
        {sizes && <SizeSelector sizes={sizes} currentSize={currentSize} onChange={changeSize} />}
        {stuffedCrustIsAvailable && (
          <BorderToggle
            className={cx('PizzaSelector__border')}
            selectStuffedCrust={selectStuffedCrust}
            stuffedCrustsAvailable={stuffedCrustsAvailable}
            activeStuffedCrust={activeStuffedCrust}
          />
        )}
      </div>
    </div>
  );
}

PizzaSelector.defaultProps = {
  className: '',
  leftSidePizzaId: 0,
  rightSidePizzaId: 0,
  stuffedCrustsAvailable: [],
};

PizzaSelector.propTypes = {
  className: PropTypes.string,
  sizes: PropTypes.array.isRequired,
  doughTypes: PropTypes.array.isRequired,
  changeSize: PropTypes.func.isRequired,
  changeDough: PropTypes.func.isRequired,
  selectStuffedCrust: PropTypes.func.isRequired,
  toggleStuffedCrust: PropTypes.func.isRequired,
  stuffedCrustsAvailable: PropTypes.array,
  activeStuffedCrust: PropTypes.string.isRequired,
  leftSidePizzaId: PropTypes.number,
  rightSidePizzaId: PropTypes.number,
  stuffedCrustIsAvailable: PropTypes.bool,
  currentSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  currentDough: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
